import * as tslib_1 from "tslib";
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
var delimiter = '-';
var FacetRoutingService = /** @class */ (function (_super) {
    tslib_1.__extends(FacetRoutingService, _super);
    function FacetRoutingService(router, route) {
        var _this = _super.call(this) || this;
        _this.router = router;
        _this.route = route;
        _this.source = route.queryParams.pipe(map(_this.parseFacets));
        return _this;
    }
    Object.defineProperty(FacetRoutingService.prototype, "commands", {
        get: function () {
            return this.route.snapshot.url.map(function (seg) { return seg.path; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FacetRoutingService.prototype, "queryParams", {
        get: function () {
            return this.route.snapshot.queryParams;
        },
        enumerable: true,
        configurable: true
    });
    FacetRoutingService.prototype.parseFacets = function (params) {
        return Object.keys(params)
            .reduce(function (prev, curr) {
            var _a;
            return Object.assign(prev, (_a = {},
                _a[curr] = params[curr].split(delimiter),
                _a));
        }, {});
    };
    FacetRoutingService.prototype.toggleFacet = function (facet) {
        this.router.navigateByUrl(this.router.createUrlTree(this.commands, {
            relativeTo: this.route,
            queryParams: this.mergeSingle(facet),
            queryParamsHandling: null,
        }));
    };
    FacetRoutingService.prototype.mergeSingle = function (facet) {
        var _a;
        var current = tslib_1.__assign({}, this.queryParams);
        var applied = current[facet.group];
        if (applied && FacetRoutingService.isInString(applied, facet.code)) {
            var newFacets = applied.split(delimiter)
                .filter(function (appliedFacet) { return appliedFacet !== facet.code; });
            if (!newFacets.length)
                delete current[facet.group];
            else
                current[facet.group] = newFacets.join(delimiter);
        }
        else if (applied) {
            current[facet.group] = "" + current[facet.group] + delimiter + facet.code;
        }
        else {
            current = Object.assign(current, (_a = {},
                _a[facet.group] = facet.code,
                _a));
        }
        return current;
    };
    FacetRoutingService.isInString = function (searchValue, value) {
        var first = searchValue.indexOf("" + delimiter + value) !== -1;
        var middle = searchValue.indexOf("" + delimiter + value + delimiter) !== -1;
        var last = searchValue.indexOf("" + value + delimiter) !== -1;
        return searchValue === value ||
            (middle || last && !first || first && !last);
    };
    return FacetRoutingService;
}(Observable));
export { FacetRoutingService };
